const HOST = process.env.REACT_APP_API_URL || "https://api.ggplayer.app/";
const RESELLER_HOST = process.env.REACT_APP_RESELLER_URL || "https://reseller.ggplayer.app/";

const API_HOST = `${HOST}api/`;

export { API_HOST, HOST, RESELLER_HOST, };
